"use client";

import { motion } from "framer-motion";
import { useLang } from "@/contexts/language-context";
import { Sparkles } from "lucide-react";

const SLIDES = [
  { eyebrow: { en: "House special", es: "Especial de la casa" }, title: "Birria Tacos", price: "$9", color: "#F4722B" },
  { eyebrow: { en: "Refreshing", es: "Refrescante" }, title: "Agua Fresca", price: "$4", color: "#D7263D" },
  { eyebrow: { en: "Crowd favorite", es: "Favorito de todos" }, title: "Elote Loco", price: "$5.50", color: "#F4722B" },
];

export default function KioskAttractScroll() {
  const { t } = useLang();

  return (
    <section className="relative py-32 px-6 bg-white overflow-hidden">
      <div className="max-w-[1200px] mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16 max-w-[760px] mx-auto"
        >
          <div className="text-[11px] font-black tracking-widest uppercase mb-4" style={{ color: "#D7263D" }}>
            {t("Attract loop", "Loop de atracción")}
          </div>
          <h2 className="text-4xl md:text-[64px] font-black tracking-[-0.03em] leading-[1.02] text-redy-charcoal">
            {t("Idle? ", "¿Inactivo? ")}
            <span className="text-redy-charcoal/30">{t("It sells.", "Vende.")}</span>
          </h2>
          <p className="text-[16px] font-medium text-redy-secondary leading-relaxed mt-6">
            {t(
              "When nobody's at the kiosk, the screen rotates your top sellers with hero photography. People walk by, see the special, walk over.",
              "Cuando nadie está en el kiosko, la pantalla rota tus best-sellers con foto enorme. La gente pasa, ve la oferta, se acerca."
            )}
          </p>
        </motion.div>

        {/* 3 slides displayed side by side */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-[1080px] mx-auto">
          {SLIDES.map((s, i) => (
            <motion.div
              key={s.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.6, delay: 0.1 * i, ease: [0.21, 0.47, 0.32, 0.98] }}
              className="relative rounded-[24px] overflow-hidden shadow-[0_30px_80px_rgba(0,0,0,0.10)] aspect-[3/4]"
              style={{
                background: `linear-gradient(135deg, ${s.color} 0%, #1A1A1A 110%)`,
              }}
            >
              <div
                className="absolute inset-0 opacity-50"
                style={{
                  backgroundImage:
                    "radial-gradient(circle at 30% 30%, rgba(255,255,255,0.30) 0%, transparent 50%)",
                }}
              />
              <div className="relative h-full flex flex-col justify-between p-6 text-white">
                <div>
                  <div className="inline-flex items-center gap-1.5 bg-white/15 backdrop-blur-sm border border-white/20 px-2.5 py-1 rounded-full">
                    <Sparkles className="w-3 h-3" />
                    <span className="text-[10px] font-black uppercase tracking-widest">
                      {t(s.eyebrow.en, s.eyebrow.es)}
                    </span>
                  </div>
                </div>
                <div>
                  <div className="text-[40px] md:text-[48px] font-black leading-[0.95] tracking-tight mb-2">
                    {s.title}
                  </div>
                  <div className="text-[20px] font-black tabular-nums">{s.price}</div>
                  <div className="text-[10px] font-bold uppercase tracking-widest text-white/70 mt-3">
                    {t("Tap to add", "Toca para agregar")}
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6, delay: 0.5 }}
          className="text-center text-[14px] font-medium text-redy-secondary mt-12"
        >
          {t(
            "They rotate on their own. Tap any item to jump straight into ordering it.",
            "Rotan solos. Toca cualquier item para saltar a ordenarlo."
          )}
        </motion.p>
      </div>
    </section>
  );
}
